import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest ,HttpResponse,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs'; 

import  {environment} from '../environments/environment'
import { catchError, finalize, map } from 'rxjs/operators';
import { EncryptionService } from './services/encryption.service';



@Injectable({
    providedIn: 'root'
  })
  
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(private encryptionService: EncryptionService) {}

    // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //   // add custom header
    //   const customReq = request.clone({
    //     headers: request.headers.set('ch_app_access_token', environment.ch_app_access_token)
    //   }); 
    //   // pass on the modified request object
    //   return next.handle(customReq);
    // }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      let modifiedReq = request;    
      let mapUrl = request.url.split('.');     
      if(mapUrl[0] != 'https://ch-cc' && request.url != 'https://jsonip.com' &&  mapUrl[0] != 'https://maps' && request.url != 'https://infoaidsqa.callhealth.com/socket.io') {
      //  modifiedReq = request.clone({ 
      //   headers: request.headers.set('ch_app_access_token', environment.ch_app_access_token)
      // });
      if (
        request.url.includes(environment.busUrl) &&
        !request.url.includes("/uploadUtils/") &&
        !request.url.includes("/doctor/getEhrDocuments/")
      ) {
        modifiedReq = request.clone({
          headers: request.headers.set("ch_app_access_token", environment.ch_app_access_token),
          body: {
            // encryptedData:this.encryptionService.encrypt(JSON.stringify(req.body)),
            request: this.encryptionService.encrypt(JSON.stringify(request.body)),
          },
        });
      } else {
        // debugger
        modifiedReq = request.clone({
          headers: request.headers.set("ch_app_access_token", environment.ch_app_access_token),
        });
      }
    }
    //  return next.handle(modifiedReq).pipe(
    //   finalize(() => {
    //     // this.loaderService.stop();
    //   }),
    //   catchError((val:[]) => {
    //     // this.loaderService.stop();
    //     // this.notificationService.error('An Error Occured');
    //    console.log('subscription error ', val);
    //   //  this.api.errorHandling.next(val['error'])
    //      return val;
    //   })
    // ); 

    if (request.url.includes(environment.busUrl) && !request.url.includes('/uploadUtils/') && !request.url.includes('/doctor/getEhrDocuments/')) {
      return next.handle(modifiedReq).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            return event.clone({ body: JSON.parse(this.encryptionService.decrypt(event.body.response)) });
          }
          return event;
        }),
        finalize(() => {
        }),
        catchError(val => {
          //  if(val.status == 500){
          //    alert(val.status+"error")
          //  }
          // this.loaderService.stop();
          return [];
        })
      );
    } else {
      return next.handle(modifiedReq);

    }  
    }
  }